import styled, {css} from 'styled-components'

export const StyledRowSelectionText = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['500']};
    `
)
